module.exports = __webpack_public_path__ + "static/cortex-value-gobig-min-476560de46753f333d42f7dc8ef73599.png";